import React from "react";
import { Container, TextItem } from "./styles";

export interface INoInfo {
  noInfo?: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  dashed?: boolean;
  align?: "center" | "left";
  compact?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

export default function NoInfo({
  noInfo,
  children,
  icon,
  action,
  dashed = false,
  align = "center",
  compact = false,
  style,
  className,
}: INoInfo) {
  return (
    <Container
      $dashed={dashed}
      $align={align}
      $compact={compact}
      style={style}
      className={className}
    >
      {icon}
      <TextItem $align={align}>{noInfo || children}</TextItem>
      {action}
    </Container>
  );
}